/**
 * LA FORMA DEL ENLACE de «¿olvidó su contraseña?» (db/106), en un solo archivo y
 * compartido por los TRES lados que tienen que estar de acuerdo:
 *
 *  · el servidor que ARMA el enlace          (`netlify/functions/_lib/clave-reinicio.ts`)
 *  · la ruta que lo ATIENDE                  (`src/rutas.tsx`)
 *  · la pantalla que lee el token de la URL  (`src/paginas/ClaveNueva.tsx`)
 *
 * Está aparte de `_lib/clave-reinicio.ts` —donde vive el resto del circuito— por
 * una razón mecánica: ese módulo usa `node:crypto` para fabricar y hashear el
 * token, así que el navegador NO puede importarlo. Si estas dos constantes
 * vivieran allí, la pantalla tendría que repetirlas a mano; y el día que alguien
 * cambiara la ruta, el correo seguiría mandando a la vieja y el enlace llevaría
 * a una página en blanco sin que nada diera error. Este archivo es JavaScript a
 * secas —ni Node, ni DOM, ni React— justo para poder ser el único sitio.
 *
 * `tsconfig.json` mete `src` y `netlify/functions` en el MISMO proyecto, así que
 * compartir type-chequea, igual que con `src/lib/clave.ts`.
 */

/** La ruta de la pantalla que canjea el enlace. Con la barra inicial. */
export const RUTA_CLAVE_NUEVA = '/clave-nueva';

/**
 * El nombre del parámetro que lleva el token. Corto a propósito: el enlace
 * entero viaja en un correo, y hay clientes que parten las líneas largas.
 */
export const PARAM_TOKEN = 't';
